import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.79688 15.1494C6.95312 15.3838 7.1875 15.4619 7.5 15.4619C7.77344 15.4619 8.00781 15.3838 8.20312 15.1494L19.7266 3.66504C19.8828 3.50879 20 3.27441 20 2.96191C20 2.68848 19.8828 2.4541 19.7266 2.25879L18.2812 0.852539C18.0859 0.657227 17.8516 0.540039 17.5781 0.540039C17.3047 0.540039 17.0703 0.657227 16.875 0.852539L7.5 10.2275L3.125 5.85254C2.89062 5.65723 2.65625 5.54004 2.38281 5.54004C2.10938 5.54004 1.875 5.65723 1.71875 5.85254L0.273438 7.25879C0.078125 7.4541 0 7.68848 0 7.96191C0 8.27441 0.078125 8.50879 0.273438 8.66504L6.79688 15.1494Z",
		fill: "currentColor"
	})
});
export default SvgCheck;
